import Vue from 'vue'
import VueRouter from 'vue-router'
import homeManage from './homeManage'
import aboutManage from './aboutManage'
import shopManage from './shopManage'
import brandManage from './brandManage'
import teamWorkManage from './teamWorkManage'
import planManage from './planManage'
import ideaManage from './ideaManage'
import consultManage from './consultManage'

Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        redirect: "/home"
    },
    ...homeManage,
    ...aboutManage,
    ...shopManage,
    ...brandManage,
    ...teamWorkManage,
    ...planManage,
    ...ideaManage,
    ...consultManage

]

const router = new VueRouter({
    routes
})

export default router